<template>
  <div>
    <div v-if="test">
      <div class=" row box-container py-2 my-2 mx-0 align-items-center">
        <div class="col-11 d-flex flex-column">
          <label class="text-muted" style="font-size: 14px;">
            Nombre de la Prueba
          </label>
          <span style="font-size: 16px;">
            {{ test.name }}
          </span>
        </div>
        <div class="col-1 d-flex justify-content-end">
          <action-button
            v-if="!readOnly"
            type="button"
            i="fas fa-times-circle"
            variant="outline-danger text-danger"
            class="p-3 mr-2"
            @click="remove(test.id, test.classificationId)"
          />
          <action-button
            v-if="!readOnly"
            type="button"
            i="fas fa-edit"
            variant="success"
            class="p-3"
            @click="edit(test.id, test.classificationId)"
          />
          <action-button
            v-if="readOnly"
            type="button"
            i="fas fa-eye"
            variant="success"
            class="p-3"
            @click="view(test.id, test.classificationId)"
          />
        </div>
      </div>
    </div>

    <div class="p-4 box-container text-center col-12" v-else>
      <p class="text-gray">
        Deberá crear el examen en la pantalla de configurar el formulario de las
        pruebas:
      </p>
      <action-button
        type="button"
        i="fa fa-file-plus pl-2"
        variant="outline-success text-success"
        class="px-1 mr-2 actions bg-white"
        @click="configureTestForm"
        :disabled="readOnly"
      >
        Configurar Formulario de Pruebas
      </action-button>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import {
  getWorkshopTests,
  removeQuestionnaire,
} from '@/services/operations/dashboard-management';
import QuestionnaireClassificationType from '@/utils/constants/operations-dashboard-management/QuestionnaireClassificationType';
import alert from '@/mixin/alert.mixin';
export default {
  name: 'WorkshopConfigureTestForm',
  components: {
    ActionButton,
  },
  mixins: [alert],
  props: {
    workshopId: {
      type: Number,
      default: () => null,
    },
    isPreOrPostTest: {
      type: Boolean,
      default: () => false,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    postId: {
      type: Number,
      default: () => 0,
    },
    classificationId: {
      type: Number,
      default: () => 0,
    },
  },
  async mounted() {
    if (this.postId) await this.getWorkshopTests();
  },
  data() {
    return {
      test: null,
    };
  },
  methods: {
    async configureTestForm() {
      await this.emitEvent();
      const route = {
        name: 'dashboardMaintenanceConfigureTestForm',
        params: { postId: this.postId, workshopId: this.workshopId },
        query: { isPreOrPostTest: this.isPreOrPostTest },
      };
      this.$router.push(route);
    },
    emitEvent() {
      return new Promise((resolve) => {
        this.$emit('partial-update', resolve);
      });
    },
    async getWorkshopTests() {
      const payload = {
        postId: this.postId,
        classificationId: this.classificationId,
      };
      const { data } = await getWorkshopTests(payload);
      this.test = data;
      this.$emit('test-loaded', data);
    },
    edit(id, classificationId) {
      if (this.readOnly) return;

      const isPreOrPostTest = [
        QuestionnaireClassificationType.PostTest,
        QuestionnaireClassificationType.PreTest,
      ].includes(classificationId);
      this.$router.push({
        name: 'dashboardMaintenanceConfigureTestForm',
        params: {
          id,
          postId: this.postId,
          workshopId: this.workshopId,
        },
        query: { isPreOrPostTest },
      });
    },
    view(id, classificationId) {
      const isPreOrPostTest = [
        QuestionnaireClassificationType.PostTest,
        QuestionnaireClassificationType.PreTest,
      ].includes(classificationId);
      this.$router.push({
        name: 'dashboardMaintenanceConfigureTestForm',
        params: {
          id,
          postId: this.postId,
          workshopId: this.workshopId,
          readOnly: true,
        },
        query: { isPreOrPostTest },
      });
    },
    async remove(id, classificationId) {
      if (this.readOnly) return;

      const isPreOrPostTest = [
        QuestionnaireClassificationType.PostTest,
        QuestionnaireClassificationType.PreTest,
      ].includes(classificationId);

      const payload = {
        questionnaireTypeId: id,
        postId: this.postId,
        isPreOrPostTest,
      };
      const confirmation = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea Eliminar?',
        'Si',
        'No'
      );

      if (!confirmation) return;

      try {
        await removeQuestionnaire(payload);
        await this.getWorkshopTests();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>
<style scoped>
.box-container {
  background-color: #f7f7f7;
}
</style>
